import { PageHero } from "@/components/sections/PageHero";
import { COMPANY, IMAGES } from "@/lib/site";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero eyebrow="Legal" title="Privacy Policy" image={IMAGES.steelTexture} />
      <section className="section px-6 lg:px-10 max-w-4xl space-y-6 text-zinc-300 leading-relaxed">
        <p><strong className="text-white">Effective Date:</strong> {new Date().toLocaleDateString()}</p>
        <p>{COMPANY.name} ("we", "us") respects your privacy. This policy describes what information we collect through this website and how we use it.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">What We Collect</h2>
        <p>We collect information you voluntarily submit through our Request a Quote and Contact forms — including name, company, email, phone, and project details. We also collect standard server logs (IP address, browser, and pages viewed).</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">How We Use It</h2>
        <p>Submitted information is used solely to respond to quote requests, provide services, and communicate with you about your project. We do not sell your information.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Cookies</h2>
        <p>This site may use cookies for basic analytics and session state. You may disable cookies in your browser without loss of essential functionality.</p>

        <h2 className="font-display text-3xl text-white tracking-tight pt-6">Contact</h2>
        <p>Questions about this policy: {COMPANY.email} · {COMPANY.phone}</p>
      </section>
    </div>
  );
}
